import { PostgresIntegration } from 'libs/end-to-end/src/types/databases/integrations/postgres-integration';

export const validatePostgresIntegrationShared = ({
  integration,
}: {
  integration: PostgresIntegration | null;
}): string[] => {
  const errorReasons: string[] = [];

  if (!integration) {
    errorReasons.push('Integration is required.');
    return errorReasons;
  }

  const { database, tables, passwordReference, port, user, host, retryCount } =
    integration;

  for (const table of tables) {
    if (table.tableName.trim() === '') {
      errorReasons.push('One or more of your table names is empty.');
    }
  }

  if (database.trim() === '') {
    errorReasons.push('Database name is required.');
  }

  if (host.trim() === '') {
    errorReasons.push('Host is required.');
  }

  if (user.trim() === '') {
    errorReasons.push('Username is required.');
  }

  if (port <= 0) {
    errorReasons.push('Port must be greater than 0.');
  }

  if (!passwordReference) {
    errorReasons.push('You must provide a secret reference for your password.');
  }

  if (retryCount <= 0) {
    errorReasons.push('Retry count must be greater than 0.');
  }

  if (retryCount > 5) {
    errorReasons.push('Retry count must be less than or equal to 5.');
  }

  return errorReasons;
};
